export const userSchema = {
    selectGroup: true,
    selectAll: true,
    maxPlaceholderOpts: 1,
    minHeight: 10,
    maxHeight: 365,
    // search: true,
    texts: {
        // search: 'Поиск пользователей',
        placeholder: 'Выберите пользователей',
        selectedOptions: 'Пользователей: ',
        globalSelectAll: 'Выбрать все',
        globalUnselectAll: 'Убрать все',
        selectAll: 'выбрать',
        unselectAll: 'убрать',
    },
}
export const eventTypesSchema = {
    selectGroup: false,
    selectAll: true,
    maxPlaceholderOpts: 1,
    minHeight: 10,
    maxHeight: 365 * 1.5,
    search: true,
    texts: {
        search: 'Поиск событий',
        placeholder: 'Список событий',
        selectedOptions: 'Событий: ',
        globalSelectAll: 'Выбрать все',
        globalUnselectAll: 'Убрать все',
        selectAll: 'выбрать',
        unselectAll: 'убрать',
    },
}
